module.exports = __webpack_public_path__ + "static/media/close_case.eb4adbeb.svg";